import React from "react";
import "./Solar_Power.css";

import { SolarPowers } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading";

const Solar_Power = () => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [solarpower, setSolarPower] = useState([]);

  const getSolarPowers = async () => {
    const res = await SolarPowers();
    if (res?.success) {
      setSolarPower(res.data);
    }
  };
  useEffect(() => {
    getSolarPowers();
  }, []);

  return (
    <section className="Solar_Power">
      <div className="container">
        <Common_heading
          title="Smart IT Solutions for Every Business"
          subtitle="Reliable technology services for growth and innovation."
        />

        <div className="solar_card_div">
          <div className="row g-3 ">
            {solarpower.map((item, index) => (
              <div
                className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mt-3"
                key={index}
              >
                <div className="solar_box">
                  <div className="solar_img_div">
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt={item.title}
                      className="solar_img"
                    />
                  </div>
                  <div className="solar_content">
                    <h5 className="card_title">{item.name}</h5>
                    <p className="card_title">{item.subtitle}</p>
                    <p className="card_text">
                      {htmlToReactParser.parse(item.description)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solar_Power;
